<template>
    <q-card-section class="modal-content">
        <span class="modal-title">Регистрация</span>
        <div class="row q-col-gutter-sm">
            <div class="col-12">
                <q-input
                    outlined
                    class="required"
                    v-model="last_name"
                    label="Фамилия"
                    :error-message="getError('last_name')"
                    :error="hasError('last_name')" />
                <q-input
                    outlined
                    class="required"
                    v-model="first_name"
                    label="Имя"
                    :error-message="getError('first_name')"
                    :error="hasError('first_name')" />
                <q-input
                    outlined
                    class="required"
                    v-model="middle_name"
                    label="Отчество"
                    :error-message="getError('middle_name')"
                    :error="hasError('middle_name')" />
            </div>
            <div class="col-12">
                <q-radio v-model="gender" val="0" label="Женский" />
                <q-radio v-model="gender" val="1" label="Мужской" />
            </div>
            <div class="col-12">
                <q-input
                    outlined
                    class="required"
                    v-model="phone_number"
                    @blur="blurPhoneNumber"
                    @focus="focusPhoneNumber"
                    mask="+7 (###) ###-##-##"
                    label="Ваш телефон"
                    :fill-mask="fillPhoneNumberMask"
                    :error-message="getError('phone_number')"
                    :error="hasError('phone_number')" />
                <q-input
                    outlined
                    class="required"
                    v-model="email"
                    label="Ваш email"
                    :error-message="getError('email')"
                    :error="hasError('email')" />
                <q-input
                    outlined
                    class="required"
                    v-model="password"
                    label="Пароль"
                    :type="isPwd ? 'password' : 'text'"
                    :error-message="getError('password')"
                    :error="hasError('password')">
                    <template v-slot:append>
                        <q-icon
                            :name="isPwd ? 'visibility_off' : 'visibility'"
                            class="cursor-pointer"
                            @click="isPwd = !isPwd"
                        />
                    </template>
                </q-input>
            </div>
        </div>
        <div class="col-12 q-mb-md">
            <div class="row">
                <q-checkbox v-model="subscribe" subscribe label="Подписка на новости" />
            </div>
            <div class="row q-mt-xs">
                <q-btn class="full-width" label="Зарегистрироваться" @click.prevent="submitRegistration" />
            </div>
            <div class="row confirmation q-mt-md">
                Нажимая на кнопку вы соглашаетесь с <a @click.prevent="$root.redirect('/offer/#privacy')" href="javascript: void(0)" title="Конфиденциальность и защита">политикой конфиденциальности персональных данных</a>
            </div>
        </div>
    </q-card-section>
</template>

<script>
    import { mapMutations, mapActions, mapGetters } from 'vuex';
    import phoneNumberMixin from './../../../mixins/phone_number';

    export default {
        name: 'Registration',
        mixins: [
            phoneNumberMixin
        ],
        data () {
            return {
                isPwd: true,
                fillMask: false,
            }
        },
        methods: {
            ...mapMutations('auth', [
                'hideModal',
            ]),

            ...mapActions('auth', [
                'register'
            ]),

            getPhoneNumber () {
                return this.phone_number;
            },

            setPhoneNumberCallback (value) {
                return this.phone_number = value ? value : '';
            },

            submitRegistration () {
                let _this = this;
                _this.register();
            },
            setFormValue(payload) {
                this.$store.commit('auth/setFormValue', payload);
            }
        },
        computed: {
            ...mapGetters('auth', [
                'hasError',
                'getError'
            ]),
            first_name: {
                get () {
                    return this.$store.state.auth.registration.first_name;
                },
                set (value) {
                    this.setFormValue({key: 'first_name', value: value});
                }
            },
            last_name: {
                get () {
                    return this.$store.state.auth.registration.last_name;
                },
                set (value) {
                    this.setFormValue({key: 'last_name', value: value});
                }
            },
            middle_name: {
                get () {
                    return this.$store.state.auth.registration.middle_name;
                },
                set (value) {
                    this.setFormValue({key: 'middle_name', value: value});
                }
            },
            gender: {
                get () {
                    return this.$store.state.auth.registration.gender;
                },
                set (value) {
                    this.setFormValue({key: 'gender', value: value});
                }
            },
            phone_number: {
                get () {
                    return this.$store.state.auth.registration.phone_number;
                },
                set (value) {
                    this.setFormValue({key: 'phone_number', value: value});
                }
            },
            email: {
                get () {
                    return this.$store.state.auth.registration.email;
                },
                set (value) {
                    this.setFormValue({key: 'email', value: value});
                }
            },
            password: {
                get () {
                    return this.$store.state.auth.registration.password;
                },
                set (value) {
                    this.setFormValue({key: 'password', value: value});
                }
            },
            subscribe: {
                get () {
                    return this.$store.state.auth.registration.subscribe;
                },
                set (value) {
                    this.setFormValue({key: 'subscribe', value: value});
                }
            },
            accept: {
                get () {
                    return this.$store.state.auth.registration.accept;
                },
                set (value) {
                    this.setFormValue({key: 'accept', value: value});
                }
            },
        }
    }
</script>
